import React, { Component, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ResizeObserverErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): State {
        return { hasError: false };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        if (error.message.includes('ResizeObserver loop')) {
            return;
        }
        console.error('Uncaught error:', error, errorInfo);
    }

    componentDidMount() {
        window.addEventListener('error', this.handleError);
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.handleError);
    }

    handleError = (event: ErrorEvent) => {
        if (event.message && event.message.includes('ResizeObserver loop')) {
            event.stopImmediatePropagation();
            event.preventDefault();
            this.removeWebpackOverlay();
        }
    };

    removeWebpackOverlay = () => {
        const overlay = document.getElementById('webpack-dev-server-client-overlay');
        if (overlay) {
            overlay.remove();
        }
    };

    render() {
        return this.props.children;
    }
}

export default ResizeObserverErrorBoundary;
